/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 기타 공용 스타일드 컴포넌트
 * 버전 : 1.0
 * 파일명 : Etc.ts
 * 작성자 : 강동형
 * 작성일 : 2025-12-30
 * ================================================================ 
 * ================================================================ */

import styled from "styled-components";

// 두꺼운 가로선
export const ThicDivider = styled.div`
    min-height: 10px;
    background-color: #f5f5f5;
`;